import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];

  connect() {
    console.log("Orders controller connected");
    console.log("Controller element:", this.element);

    // Initialize drawer functionality
    this.initializeDrawer();

    // Check if drawer should be reopened after page reload
    this.checkDrawerState();
    // Add event listeners for buttons that might be outside the controller scope
    this.setupEventListeners();

    // Listen for Turbo Frame loads to reinitialize drawer functionality
    document.addEventListener('turbo:frame-load', this.handleFrameLoad.bind(this));
  }

  initializeDrawer() {
    // Add event listener for escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeFiltersDrawer();
      }
    });
  }

  openFiltersDrawer() {
    console.log("openFiltersDrawer called");
    const drawerElement = document.getElementById("orders-drawer");
    const backdropElement = document.getElementById("orders-drawer-backdrop");

    console.log("Drawer element:", drawerElement);
    console.log("Backdrop element:", backdropElement);

    if (!drawerElement) {
      console.error("Drawer element not found. Make sure the drawer is rendered in the DOM.");
      return;
    }

    // Show the backdrop
    if (backdropElement) {
      backdropElement.classList.remove('hidden');
    } else {
      console.warn("Backdrop element not found");
    }

    // Show the drawer
    drawerElement.classList.remove('hidden');
    drawerElement.classList.remove('translate-x-full');
    drawerElement.classList.add('translate-x-0');

    // Prevent body scroll
    document.body.classList.add('overflow-hidden');

    // Focus the close button for accessibility
    const closeButton = drawerElement.querySelector('button[data-action*="closeFiltersDrawer"]');
    if (closeButton) {
      closeButton.focus();
    }

    console.log("Drawer opened successfully");
  }

  closeFiltersDrawer() {
    console.log("Orders controller: closeFiltersDrawer called")
    console.log("Close button clicked!")

    const drawerElement = document.getElementById("orders-drawer");
    const backdropElement = document.getElementById("orders-drawer-backdrop");

    if (drawerElement) {
      // Hide the backdrop
      if (backdropElement) {
        backdropElement.classList.add('hidden');
      }

      // Hide the drawer
      drawerElement.classList.add('translate-x-full');
      drawerElement.classList.remove('translate-x-0');

      // Re-enable body scroll
      document.body.classList.remove('overflow-hidden');

      // Clear the drawer state from sessionStorage
      sessionStorage.removeItem('orders-drawer-open');
    } else {
      console.warn("Drawer element not found when trying to close");
    }
  }

  checkDrawerState() {
    // Check if drawer was open before page reload
    const wasDrawerOpen = sessionStorage.getItem('orders-drawer-open')

    if (wasDrawerOpen === 'true') {
      console.log("Reopening drawer after page reload")
      // Clear the stored state
      sessionStorage.removeItem('orders-drawer-open')

      // Reopen the drawer after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.openFiltersDrawer()
      }, 100)
    }
  }

  setupEventListeners() {
    console.log("Setting up event listeners...")
    
    // Add click event listeners for reset and close buttons only
    document.addEventListener('click', (event) => {
      // Check if reset button was clicked
      if (event.target.closest('[data-action*="handleFilterReset"]') &&
          !event.target.closest('a[href*="status"]')) {
        console.log("Reset button clicked via event listener")
        this.handleFilterReset()
      }

      // Check if close button was clicked
      if (event.target.closest('[data-action*="closeFiltersDrawer"]') &&
          !event.target.closest('a[href*="status"]')) {
        console.log("Close button clicked via event listener")
        this.closeFiltersDrawer()
      }
    })
  }

  handleFilterReset() {
    console.log("Orders controller: handleFilterReset called")
    console.log("Reset button clicked!")

    // Find the filter form
    const filterForm = document.getElementById("orders-filter-form")
    if (!filterForm) {
      console.error("Filter form not found")
      return
    }

    // Clear all SelectMulti components
    const selectMultiElements = filterForm.querySelectorAll('[data-controller*="uikit--select-multi"]')
    selectMultiElements.forEach((selectMultiElement) => {
      const selectMultiController = this.application.getControllerForElementAndIdentifier(
        selectMultiElement,
        'uikit--select-multi'
      )

      if (selectMultiController && selectMultiController.clear) {
        selectMultiController.clear()
      }
    })

    // Build the reset URL (remove all filter parameters)
    const currentUrl = new URL(window.location)
    const currentParams = currentUrl.searchParams

    // Remove filter-related parameters but preserve status
    for (let [key] of currentParams.entries()) {
      if (key.startsWith('filter_') || key === 'page') {
        currentParams.delete(key)
      }
    }

    // Preserve the status parameter to maintain the current tab
    const currentStatus = currentParams.get('status')
    if (currentStatus) {
      currentParams.set('status', currentStatus)
    }
    
    const resetUrl = `${currentUrl.pathname}?${currentParams.toString()}`

    // Use Turbo Frame to update the orders table
    const turboFrame = document.querySelector('turbo-frame#orders-table')
    if (turboFrame) {
      // Update the browser URL first
      window.history.pushState({}, '', resetUrl)

      // Update the Turbo Frame source to trigger a Turbo Frame request
      turboFrame.src = resetUrl
    } else {
      console.warn("Turbo Frame not found, falling back to full page reload for reset")
      // Fallback to full page reload if Turbo Frame is not available
      window.location.href = resetUrl
    }
  }

  handleFrameLoad(event) {
    // Only handle orders-table frame loads
    if (event.target.id === 'orders-table') {
      console.log("Orders table frame loaded, reinitializing drawer functionality")
      // Reinitialize drawer functionality after frame load
      this.initializeDrawer();
      this.setupEventListeners();
    }
  }
}
